module.exports = __webpack_public_path__ + "img/rugbyLes3.6a6a3d02.jpg";